export default {
  partNoPlaceholder: 'Teile-Nr. eingeben',
  header: 'Bitte eingeben',
};
